var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-item range-picker" }, [
    _c("h3", [_vm._t("default")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "range-box" }, [
      _c(
        "div",
        { staticClass: "range-scale" },
        _vm._l(_vm.model.ticks, function (tick, index) {
          return _vm.model.ticks
            ? _c("div", { style: _vm.positionOnRange(tick) }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        _vm.model.value = tick
                      },
                    },
                  },
                  [
                    _vm._v(_vm._s(_vm.format(tick)) + "\n                    "),
                    index == _vm.model.ticks.length - 1
                      ? [_vm._v("+")]
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.model.value,
            expression: "model.value",
          },
        ],
        attrs: {
          type: "range",
          min: _vm.model.min,
          max: _vm.model.max,
          step: _vm.model.step,
        },
        domProps: { value: _vm.model.value },
        on: {
          input: function ($event) {
            _vm.model.done = true
          },
          __r: function ($event) {
            return _vm.$set(_vm.model, "value", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "range-value-box" }, [
        _c(
          "div",
          {
            staticClass: "range-value",
            style: _vm.positionOnRange(_vm.model.value),
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.format(_vm.model.value)) +
                "\n            "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }